export const common = {
  nav: {
    home: 'Home',
    services: 'Services',
    travel: 'Travel Guide',
    school: 'School Support',
    company: 'Company',
    contact: 'Contact'
  },
  hero: {
    title1: 'Your Complete Partner for',
    title2: 'Southeast Asian Business',
    subtitle1: 'From business expansion in Malaysia and Southeast Asia',
    subtitle2: 'to your children\'s education - comprehensive one-stop support',
    cta: 'Book Free Consultation',
    details: 'View Service Details'
  },
  services: {
    title: 'Our Services',
    heading1: 'Supporting You with',
    heading2: 'Three Core Services',
    consulting: {
      title: 'Business Consulting',
      desc: 'Southeast Asia expansion, business operations, negotiation interpretation, real estate contracts, AI consulting, etc.'
    },
    expansion: {
      title: 'Overseas Expansion Support',
      desc: 'Comprehensive support from local entity establishment, visa acquisition, office setup to staff recruitment',
      badge: 'AI Consulting'
    },
    travel: {
      title: 'Travel Guide',
      desc: 'KL area, Malacca tours, Langkawi island guide, casino & gourmet guide, etc.',
      badge: 'KL Area・Casino Guide'
    },
    school: {
      title: 'International School Support',
      desc: 'Comprehensive support including school visits, transfer support, guardianship, etc.',
      badge: 'School Visit・Transfer'
    }
  },
  features: {
    title: 'Why Choose',
    titleHighlight: 'Us',
    subtitle: 'Over 20 years of proven track record',
    badge: 'Proven Results',
    network: {
      title: 'Local Network',
      desc: 'Extensive connections and partnerships in Malaysia',
      value: '50+ Partners'
    },
    multilingual: {
      title: 'Multilingual Support',
      desc: 'Japanese, English, Malay, Chinese, Thai support',
      value: '5 Languages'
    },
    support: {
      title: '24/7 Support',
      desc: 'Reliable support system even in emergencies'
    },
    success: {
      title: 'Success Rate',
      desc: 'Customer satisfaction and business success rate',
      value: '95%'
    }
  },
  about: {
    label: '/ About Us',
    title: 'yapauchi partners Corp. ',
    desc1: 'A specialized consulting company providing total support',
    desc2: 'for business development in Southeast Asia, especially Malaysia.',
    desc3: 'Leveraging our extensive local experience and network, we fully support your business success.',
    years: '20+',
    yearsDesc1: 'Years of Experience',
    yearsDesc2: 'Southeast Asia Business Support',
    button: 'View Company Profile'
  },
  testimonial: {
    title: '( Client Testimonials )',
    rating: '4.9',
    review: 'They supported us from company establishment in Malaysia to local staff recruitment. With accurate advice on local business practices and legal matters, we were able to start our business smoothly.',
    name: 'Mr. Tanaka',
    company: 'Manufacturing・Malaysia Expansion'
  },
  cta: {
    text1: 'Your Business Expansion',
    text2: 'in Southeast Asia',
    text3: 'We Support Your Success',
    button: 'Book Free Consultation'
  },
  footer: {
    newsletter: {
      title1: 'Stay Updated with',
      title2: 'Latest Information',
      desc: 'Latest trends and useful information on Southeast Asian business',
      placeholder: 'Email Address',
      button: 'Subscribe'
    },
    services: {
      title: 'Services',
      consulting: 'Business Consulting',
      travel: 'Travel Guide',
      school: 'School Support',
      ai: 'AI Solutions'
    },
    contact: {
      title: 'Contact',
      phone: '+60-133240652',
      email: 'shujinet@gmail.com',
      address: 'Location',
      location1: 'B-05-07 KM1 West',
      location2: 'No. 13, Jalan Jalil Perkasa 1, Bukit Jalil 57000 Kuala Lumpur, MALAYSIA'
    },
    social: {
      linkedin: 'LinkedIn',
      facebook: 'Facebook',
      instagram: 'Instagram'
    },
    copyright: '© 2025 Yamauchi Partners Corp.',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    poweredBy: 'Website Builder'
  }
};
